export default "__VITE_ASSET__CQsXihRq__"